@if (isAvailable) {
  <app-async-mat-icon-button
    title="Voir la version imprimable"
    ariaLabel="Voir la version imprimable"
    [action]="getPdf()"
    progress="bar"
    (actionResult)="onPdfLoaded($event)"
  >
    <mat-icon class="info">picture_as_pdf</mat-icon>
  </app-async-mat-icon-button>
}
